module.exports = __webpack_public_path__ + "img/banner_img_1.749cccee.png";